import React, { useMemo } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Form, FormRenderProps } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import createFocusOnErrorsDecorator from 'final-form-focus';

import { IFinalFormProps, TDefaultFormValues } from './interfaces';
import { FINAL_FORM_API } from './constants';

const FinalForm = <
  FormValues extends TDefaultFormValues = TDefaultFormValues,
  InitialValues = Partial<FormValues>,
>(
  {
    name,
    dataTest,
    render,
    withFocusOnErrors = false,
    className = null,
    decorators = [],
    mutators = {},
    ...otherProps
  }: IFinalFormProps<FormValues, InitialValues>,
) => {
  const focusOnErrors = useMemo(() => createFocusOnErrorsDecorator(), []);

  return (
    <Form<FormValues, InitialValues>
      { ...otherProps }
      onSubmit={ otherProps.onSubmit }
      decorators={ [...decorators, ...(withFocusOnErrors ? [focusOnErrors] : [])] }
      mutators={ { ...arrayMutators, ...mutators } }
      render={ (formRenderProps: FormRenderProps<FormValues, InitialValues>) => (
        <form
          name={ name }
          data-test={ dataTest }
          className={ className }
          onSubmit={ formRenderProps.handleSubmit }
        >
          { render(formRenderProps, FINAL_FORM_API) }
        </form>
      ) }
    />
  );
};

export default FinalForm;
